<div class="content">

    <!-- Begin dashboard -->
    <div class="container-fluid">

        <!-- Page Heading -->
        <div class="raw">
            <div class=" d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="dashboard-title">Staff Enrollment</h1>
            </div>

        </div>


        <!-- Content Row -->
        <div class="row">
<!--            <div class="col-xl-8">-->
<!--                <div class="form-group app-search d-none d-lg-block">-->
<!--                    <div class="position-relative">-->
<!--                        <input [(ngModel)]="searchText"-->
<!--                                 class="form-control" placeholder="Search..." type="text">-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="col-xl-2">-->
<!--                &lt;!&ndash; Dropdown for provider or staff selection &ndash;&gt;-->
<!--                <select [(ngModel)]="selectedTable" class="form-control" (change)="fetchDataBasedOnSelection()">-->
<!--                    <option value="provider">Provider</option>-->
<!--                    <option value="staff">Staff</option>-->
<!--                </select>-->
<!--            </div>-->

<!--            <div class="col-xl-2">-->
<!--                <div *ngIf="selectedTable==='provider'" class="btn-group btn-group-toggle" data-toggle="buttons">-->
<!--                    <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)" > Active</button>-->
<!--                    <button class="btn btn-danger" (click)="_fetchData(3)"> Inactive</button>-->
<!--                    <button class="btn btn-secondary active" (click)="_fetchData(1)"> All</button>-->
<!--                </div>-->
<!--                <div *ngIf="selectedTable==='staff'" class="btn-group btn-group-toggle" data-toggle="buttons">-->
<!--                    <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchStaffData(2)" > Active</button>-->
<!--                    <button class="btn btn-danger" (click)="_fetchStaffData(3)"> Inactive</button>-->
<!--                    <button class="btn btn-secondary active" (click)="_fetchStaffData(1)"> All</button>-->
<!--                </div>-->
<!--                <button *ngIf="this.authService.hasRole('client-edit')" class="btn btn-primary float-right" type="button" routerLink="register" title="Add Provider">-->
<!--                    <i class="fas fa-plus"></i>&nbsp;-->
<!--                    Add Staff-->
<!--                </button>-->
<!--            </div>-->
            <div class="col-12 d-flex flex-wrap align-items-center justify-content-between pb-2">
                <!-- Search Box -->
                <div class="col-lg-7 col-md-5 col-sm-12 ">
                  <div class="google-search-container">

                    <i class="fa fa-search search-icon"></i>

                    <input
                      (keyup)="handleKeyUp($event)"
                      [(ngModel)]="searchText"
                      #searchBox
                      class="google-search-input"
                      type="text"
                      placeholder="Search Staff..."
                    />

                    <i
                      *ngIf="searchBox.value"
                      class="fa fa-times clear-icon"
                      (click)="clearSearch(searchBox)"
                    ></i>

                  </div>
                </div>

                <!-- Dropdown -->
                <div class="col-lg-2 col-md-3 col-sm-6 d-flex justify-content-start ">
                    <select [(ngModel)]="selectedTable" class="form-control" (change)="fetchDataBasedOnSelection()">
                        <option value="provider">Provider</option>
                        <option value="staff">Staff</option>
                    </select>
                </div>

                <!-- Filter Buttons -->


                <!-- Add Button -->
                <div class="col-lg-3 col-md-4 col-sm-6 d-flex justify-content-end mt-2 mt-md-0">
                  <div *ngIf="selectedTable==='provider'" class="btn-group btn-group-toggle mx-1" data-toggle="buttons">
                    <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchData(2)">Active</button>
                    <button class="btn btn-danger" (click)="_fetchData(3)">Inactive</button>
                    <button class="btn btn-secondary active" (click)="_fetchData(1)">All</button>
                  </div>
                  <div *ngIf="selectedTable==='staff'" class="btn-group btn-group-toggle mx-1" data-toggle="buttons">
                    <button class="btn btn-success" style="background-color: #8bc34a" (click)="_fetchStaffData(2)">Active</button>
                    <button class="btn btn-danger" (click)="_fetchStaffData(3)">Inactive</button>
                    <button class="btn btn-secondary active" (click)="_fetchStaffData(1)">All</button>
                  </div>
                    <button *ngIf="this.authService.hasRole('client-edit')" class="btn btn-primary btn-add-patient" type="button" routerLink="register" title="Add Provider">
                      <i class="fas fa-plus"></i><span class="btn-label">Add Staff</span>
                    </button>
                </div>
            </div>


            <div class="col-xl-12 col-md-12 mb-2">
                    <div class="table-panel p-4">
                        <div class="table-responsive table-scroll-x">
                            <!-- Conditionally display the correct table based on selectedTable -->
                            <table class="table table-sm" matSort *ngIf="selectedTable === 'provider'" (matSortChange)="sortProviderData($event)">
                                <thead>
                                <tr>
                                    <th  scope="col">Sr.No</th>
                                    <th scope="col">Is-User</th>
                                    <th mat-sort-header="firstName" scope="col">Provider Name</th>
                                    <th mat-sort-header="clientName" scope="col">Client Name/ID</th>
                                    <th mat-sort-header="officeName" scope="col">Office Name</th>
                                    <th mat-sort-header="staffType" scope="col">Staff Type</th>
                                    <th mat-sort-header="number" scope="col">Provider Number</th>
                                    <th mat-sort-header="email" scope="col">Email</th>
                                    <th mat-sort-header="type" scope="col">Provider Type</th>
                                    <th mat-sort-header="degree" scope="col">Degree</th>
                                    <th mat-sort-header="salutation" scope="col">Salutation</th>
                                    <th mat-sort-header="taxId" scope="col">TAX ID</th>
                                    <th mat-sort-header="license" scope="col">License Number</th>
                                    <th mat-sort-header="npi" scope="col">NPI</th>
                                    <th mat-sort-header="firstLine" scope="col">Address</th>

                                    <th mat-sort-header="active" scope="col">Status</th>
<!--                                    <th scope="col">Questionnaire</th>-->
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableData| filter: searchText; let i = index">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                    <td *ngIf="table?.providerIsUser"><i class="fa-solid fa-square-check" style="color: #34ce57"></i></td>
                                    <td *ngIf="!table?.providerIsUser"><i class="fa-solid fa-square-xmark text-danger"></i></td>
                                    <td><a [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]:null"[queryParams]="this.authService.hasRole('client-edit') ?{type:selectedTable}:null">{{table.firstName ? table.firstName + ' ' + table.lastName : '-'}}</a></td>
                                    <td>{{table.clientName ? table.clientName : '-'}}</td>
                                    <td>{{table.officeName ? table.officeName : '-'}}</td>
                                    <td>{{table.staffType ? (table.staffType | titlecase) : '-'}}</td>
                                    <td>{{table.contact?.phones[0]?.number ? table.contact.phones[0]?.number : '-'}}</td>
                                    <td>{{table.contact?.email ? table.contact?.email : '-'}}</td>
                                    <td>{{table.type ? (table.type | titlecase) : '-'}}</td>
                                    <td>{{table.degree ? table.degree : '-'}}</td>
                                    <td>{{table.salutation ? table.salutation : '-'}}</td>
                                    <td>{{table.taxId ? table.taxId : '-'}}</td>
                                    <td>{{table.license ? table.license : '-'}}</td>
                                    <td>{{table.npi ? table.npi : '-'}}</td>
                                    <td>{{table.address?.firstLine ? table.address?.firstLine + ' ' + table.address?.secondLine + ' '+ table.address?.city + ' ' + table.address?.state + ' ' + table.address?.zip : '-'}}</td>

                                    <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                                                style="color: #34ce57"></i></td>
                                    <td *ngIf="!table.active"><i class="fa-solid fa-square-check "
                                                                 style="color: #dc3545"></i></td>
                                    <td>
                                        <a title="Edit" [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]:null" [queryParams]="this.authService.hasRole('client-edit') ?{type:selectedTable}:null"><i
                                                class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;
                                         <a title="Delete" (click)="deleteEntry(table.id)" ><i class="fa-solid fa-trash" style="color: #d33636;"></i></a>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableData == null || tableData.length == 0">
                                <tr>
                                    <td colspan="18" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>

                            <!-- Staff table - Only shows when selectedTable is "staff" -->
                            <table class="table" matSort *ngIf="selectedTable === 'staff'" (matSortChange)="sortStaffData($event)">
                                <thead class="thead-light">
                                <tr>
                                    <th  scope="col">Sr.No</th>
                                    <th scope="col">Is-User</th>
                                    <th mat-sort-header="firstName" scope="col">Staff Name</th>
                                    <th mat-sort-header="name" scope="col">Office Name</th>
                                    <th mat-sort-header="staffType" scope="col">Staff Type</th>
                                    <th mat-sort-header="number" scope="col">Contact Number</th>
                                    <th mat-sort-header="email" scope="col">Email</th>
                                    <th mat-sort-header="salutation" scope="col">Salutation</th>
                                    <th mat-sort-header="firstLine" scope="col">Address</th>
                                    <th mat-sort-header="active" scope="col">Status</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody *ngFor="let table of tableStaffData| filter: searchText; let i = index">
                                <tr>
                                    <th scope="row">{{i + 1}}</th>
                                    <td *ngIf="table?.staffIsUser"><i class="fa-solid fa-square-check" style="color: #34ce57"></i></td>
                                    <td *ngIf="!table?.staffIsUser"><i class="fa-solid fa-square-xmark text-danger"></i></td>
                                    <td><a [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]:null"[queryParams]="this.authService.hasRole('client-edit') ?{type:selectedTable} : null">{{table.firstName ? table.firstName + ' ' + table.lastName : '-'}}</a></td>
                                    <td>{{table?.office?.name ? table.office.name : '-'}}</td>
                                    <td>{{table?.staffType ? (table?.staffType | titlecase) : '-'}}</td>
                                    <td>{{table?.contact?.phones[0]?.number ? table.contact.phones[0].number : '-'}}</td>
                                    <td>{{table?.contact?.email ? table.contact.email : '-'}}</td>
                                    <td>{{table?.salutation ? table.salutation : '-'}}</td>
                                    <td>{{table?.address?.firstLine ? table.address.firstLine + ' ' + table.address.secondLine + ' '+ table.address.city + ' ' + table.address.state + ' ' + table.address.zip : '-'}}</td>

                                    <td *ngIf="table.active"><i class="fa-solid fa-square-check"
                                                                style="color: #34ce57"></i></td>
                                    <td *ngIf="!table.active"><i class="fa-solid fa-square-check "
                                                                 style="color: #dc3545"></i></td>
                                    <td>
                                        <a title="Edit" [routerLink]="this.authService.hasRole('client-edit') ? ['details/', table.id]:null" [queryParams]="this.authService.hasRole('client-edit') ? {type:selectedTable}:null"><i
                                                class="fa-solid fa-user-pen"></i></a>&nbsp;&nbsp;&nbsp;
                                        <a title="Delete" (click)="deleteEntry(table.id)" ><i class="fa-solid fa-trash" style="color: #d33636;"></i></a>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody *ngIf="tableStaffData == null || tableStaffData.length == 0">
                                <tr>
                                    <td colspan="6" class="text-center"> No record found !</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
            </div>
        </div>
    </div>
</div>
